var React = require('react');

function MobileMenu (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2.5","y":"2.5","width":"6","height":"6","rx":"0.5","fill":"#9E9E9E","stroke":"#9E9E9E","key":0}),React.createElement("rect",{"x":"11.5","y":"2.5","width":"6","height":"6","rx":"0.5","fill":"#9E9E9E","stroke":"#9E9E9E","key":1}),React.createElement("rect",{"x":"2.5","y":"11.5","width":"6","height":"6","rx":"0.5","fill":"#9E9E9E","stroke":"#9E9E9E","key":2}),React.createElement("rect",{"x":"11.5","y":"11.5","width":"6","height":"6","rx":"0.5","fill":"#9E9E9E","stroke":"#9E9E9E","key":3})]);
}

MobileMenu.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = MobileMenu;

MobileMenu.default = MobileMenu;
